// extracted by mini-css-extract-plugin
export default {"personalPageContainer":"_47-BijyDGwnVvqTAf5LZNA==","inlineDivs":"EryAjPRMD+bjJbtD6K6Vww==","flexPanel":"sYE2+GyYNeF1O71TlP6HJw=="};